function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "18pt",
  height: "18pt",
  viewBox: "0 0 18 18",
  version: 1.1
}, props), /*#__PURE__*/React.createElement("g", {
  id: "surface1"
}, /*#__PURE__*/React.createElement("path", {
  style: {
    "stroke": "none",
    "fillRule": "nonzero",
    "fill": "#fff",
    "fillOpacity": 1
  },
  d: "M 12.65625 6.222656 L 10.164062 6.222656 L 10.164062 4.589844 C 10.164062 3.976562 10.570312 3.832031 10.859375 3.832031 L 12.613281 3.832031 L 12.613281 1.132812 L 10.191406 1.125 C 7.503906 1.125 6.894531 3.136719 6.894531 4.425781 L 6.894531 6.222656 L 5.339844 6.222656 L 5.339844 9.003906 L 6.894531 9.003906 L 6.894531 16.875 L 10.164062 16.875 L 10.164062 9.003906 L 12.371094 9.003906 Z M 12.65625 6.222656 "
})));

export default __webpack_public_path__ + "static/media/icon_facebook.e356b1f4.svg";
export { SvgComponent as ReactComponent };